import React from "react";
import withLocalization from "../../../hoc/with-localization";
const ParamTableIntervals = props => {
    //const to_ms = val => val === null || val === undefined || isNaN(val) ? null : Math.round(val * 1000 / fd);
    const { representativeCmpx, loc, needIntervals, QTcAlg, onVerificateClick } = props;

    let S, P, PDur, QTmax, QTc, angles;
    let QRS_ms, PQ_ms, Pdur_ms, QTmax_ms, QTc_ms;

    if (representativeCmpx) {
        ({ S, P, PDur, QTmax, QTc, angles } = representativeCmpx);
        QRS_ms = S.val;
        PQ_ms = P.val !== null ? -P.val : null;
        Pdur_ms = PDur.val;
        QTmax_ms = QTmax.val;
        QTc_ms = QTc.val;
    }

    const _qtcAlg = QTcAlg?.val ?? "Bazett";
    let QTcAlgName = loc(`report.QTcAlgTitle.${_qtcAlg}`);
    //if (QTcAlgName) QTcAlgName = "(" + QTcAlgName + ")";

    const angle = _val => (_val !== null && _val !== undefined ? _val + "°" : "");
    return (
        <table className="prm-table prm-table-intervals">
            <tbody>
                {needIntervals ?? (
                    <tr className="prm-table-intervals__verify-row">
                        <td colSpan={10}>
                            <button className="button-link" onClick={onVerificateClick}>
                                {loc("buttons.verificateQRSBounds")}
                            </button>
                        </td>
                    </tr>
                )}
                <tr>
                    <td className="prm-title">QRS</td>
                    <td className="prm-data">{QRS_ms}</td>
                    <td className="prm-units">{loc("units.ms")}</td>
                    <td className="prm-gap"></td>
                    <td className="prm-title">QT</td>
                    <td className="prm-data">{needIntervals && QTmax_ms}</td>
                    <td className="prm-units">{loc("units.ms")}</td>
                    <td className="prm-gap"></td>
                    <td className="prm-title">∠QRS</td>
                    <td className="prm-data">{needIntervals && angle(angles?.QRS?.val)}</td>
                </tr>
                <tr>
                    <td className="prm-title">PQ</td>
                    <td className="prm-data">{needIntervals && PQ_ms}</td>
                    <td className="prm-units">{loc("units.ms")}</td>
                    <td className="prm-gap"></td>
                    <td className="prm-title">QTc</td>
                    <td className="prm-data">{needIntervals && QTc_ms}</td>
                    <td className="prm-units">{loc("units.ms")}</td>
                    <td className="prm-gap"></td>
                    <td className="prm-title">∠P</td>
                    <td className="prm-data">{needIntervals && angle(angles?.P?.val)}</td>
                </tr>
                <tr>
                    <td className="prm-title">P↔</td>
                    <td className="prm-data">{needIntervals && Pdur_ms}</td>
                    <td className="prm-units">{loc("units.ms")}</td>
                    <td className="prm-gap"></td>
                    <td colSpan="3" className="prm-comment">
                        {QTcAlgName}
                    </td>
                    <td className="prm-gap"></td>
                    <td className="prm-title">∠T</td>
                    <td className="prm-data">{needIntervals && angle(angles?.T?.val)}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(ParamTableIntervals);
